var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAralLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.55125,
    height: 32.553749,
    viewBox: "0 0 32.55125 32.553749",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1,843 L 596,843 L 596,-1 L -1,-1 L -1,843 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5,842.5 L 595.5,842.5 L 595.5,0.5 L 0.5,0.5 L 0.5,842.5 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.481,284.737 L 487.481,284.737 L 487.481,737.737 L 41.481,737.737 L 41.481,284.737 z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-642.77375,581.42125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 540.261,452.113 L 527.244,439.094 L 514.22,452.119 L 527.237,465.138 L 540.261,452.113 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 0.838,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.26,452.112 L 527.243,439.094 L 514.219,452.118 L 527.236,465.137 L 540.26,452.112",
    style: {
      fill: "#1670b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 533.674,455.48 C 534.342,455.48 534.429,454.986 534.429,454.434 C 534.43,453.592 534.43,452.308 534.43,450.954 C 534.663,450.949 535.766,450.954 535.766,450.954 C 536.394,450.954 536.801,450.867 536.783,450.292 C 536.76,449.507 536.046,449.618 535.534,449.618 C 535.482,449.618 533.618,449.618 533.618,449.618 C 532.805,449.619 532.92,450.339 532.92,451.245 C 532.92,452.006 532.92,453.418 532.919,454.435 C 532.89,454.987 533.064,455.48 533.674,455.48",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 520.07,455.483 C 520.866,455.483 521.11,454.978 521.29,454.437 L 522.453,450.951 C 522.453,450.951 523.034,449.76 521.959,449.615 C 521.187,449.732 521.175,450.051 520.913,450.981 L 519.258,450.981 C 518.939,449.965 519.055,449.732 518.271,449.616 C 517.167,449.733 517.719,450.982 517.719,450.982 L 518.821,454.403 C 518.993,454.936 519.239,455.483 520.07,455.483 M 520.07,454.264 L 520.623,452.137 L 519.548,452.138 L 520.07,454.264",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 525.484,455.366 C 526.036,455.366 526.593,455.377 527.169,454.61 C 527.779,453.791 527.477,452.199 526.356,452.025 C 526.559,451.647 527.228,450.631 527.228,450.631 C 527.228,450.631 527.518,450.154 527.042,449.759 C 526.2,449.44 525.979,449.934 525.979,449.934 C 525.979,449.934 525.369,450.98 524.991,451.706 L 524.294,451.706 C 524.294,451.491 524.294,450.254 524.294,450.254 C 524.294,450.254 524.341,449.586 523.597,449.615 C 522.889,449.615 522.9,450.283 522.9,450.283 L 522.899,454.437 C 522.899,455.163 522.928,455.366 524.293,455.366 C 524.671,455.366 525.17,455.366 525.484,455.366 M 524.293,454.176 C 525.542,454.152 526.065,454.291 526.065,453.565 C 526.066,452.752 525.485,452.891 524.294,452.886 C 524.294,453.362 524.294,453.595 524.293,454.176",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 530.044,455.481 C 530.839,455.481 531.084,454.975 531.264,454.435 L 532.427,450.949 C 532.427,450.949 533.008,449.758 531.933,449.613 C 531.16,449.73 531.149,450.049 530.887,450.979 L 529.232,450.979 C 528.913,449.963 529.029,449.73 528.245,449.614 C 527.141,449.73 527.692,450.979 527.692,450.979 L 528.795,454.401 C 528.958,454.906 529.213,455.481 530.044,455.481 M 530.073,454.261 L 530.626,452.135 L 529.551,452.135 L 530.073,454.261",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAralLogo);
export default __webpack_public_path__ + "static/media/Aral_Logo.78a81c767820beaa4916ee6ff716dd8e.svg";
export { ForwardRef as ReactComponent };